export const getJSTDate = (date: Date = new Date()) => {
  // 日本時間（UTC+9）のDateオブジェクトを生成
  const jstString = date.toLocaleString('en-US', { timeZone: 'Asia/Tokyo' });
  return new Date(jstString);
};

export const createJSTDate = (year: number, month: number, day: number = 1) => {
  // ブラウザのタイムゾーンに依存せず、常にJSTの00:00:00を指すDateを生成
  // 以前の文字列連結方式では day=0 (末日の取得) などで 2025-02-00 となりエラーになるため、
  // 一度標準Dateコンストラクタで日付を解決してから文字列化する
  const resolved = new Date(year, month - 1, day);
  const rY = resolved.getFullYear();
  const rM = resolved.getMonth() + 1;
  const rD = resolved.getDate();

  const dateStr = `${rY}-${String(rM).padStart(2, '0')}-${String(rD).padStart(2, '0')}T00:00:00+09:00`;
  return new Date(dateStr);
};

export const getJSTDateString = (date: Date = new Date()) => {
  // 無効な日付（Invalid Date）が渡された場合にクラッシュしないようガード
  if (!date || isNaN(date.getTime())) {
    return '1970-01-01'; // フォールバック。本来はここに来る前にデータをクリーンアップすべき
  }

  // 常に YYYY-MM-DD 形式を返す（ISO 8601 / sv-SEロケールを利用）
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Asia/Tokyo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
};

export const timeToMinutes = (time: string) => {
  if (!time) return 0;
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
};

export const minutesToTime = (minutes: number) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const displayH = h >= 24 ? h - 24 : h;
  return `${String(displayH).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

// Add calculateDurationMinutes to fix missing export error in api.ts
/**
 * 労働時間の分を計算（日跨ぎ対応）
 */
export const calculateDurationMinutes = (startTime: string, endTime: string, breakMinutes: number = 0) => {
  if (!startTime || !endTime) return 0;
  let start = timeToMinutes(startTime);
  let end = timeToMinutes(endTime);
  
  // 日跨ぎ判定: 終了時刻が開始時刻より早い場合、24時間を足す
  if (end < start) {
    end += 24 * 60;
  }
  
  return Math.max(0, end - start - breakMinutes);
};

// 日本語フォーマットの日付文字列を生成
export const formatDateJP = (d: Date) =>
  `${d.getFullYear()}年${d.getMonth()+1}月${d.getDate()}日（${['日','月','火','水','木','金','土'][d.getDay()]}）`;

export const calculateLateNightMinutes = (start: string, end: string) => {
  const sMin = timeToMinutes(start);
  let eMin = timeToMinutes(end);
  if (eMin < sMin) eMin += 24 * 60;
  
  const lateStart = 22 * 60;
  const lateEnd = 29 * 60; // 5:00 next day
  
  const overlapStart = Math.max(sMin, lateStart);
  const overlapEnd = Math.min(eMin, lateEnd);
  
  return Math.max(0, overlapEnd - overlapStart);
};
